import React from 'react';
import { Button, Form, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

interface AlternateLoginProps {
    onBack: () => void;
    onAvigilonClick: () => void;
}

const AlternateLogin: React.FC<AlternateLoginProps> = ({ onBack, onAvigilonClick }) => {
    const { t } = useTranslation();

    return (
        <>
            <Form
                layout="vertical"
                onFinish={onAvigilonClick}
                style={{ maxWidth: '400px', margin: '0 auto' }}
            >
                <Title level={4} style={{ textAlign: 'center' }}>
                    {t('auth.avigilonLogin')}
                </Title>
                <Text style={{ display: 'block', textAlign: 'center', marginBottom: '24px' }}>
                    {t('auth.alternativeLoginDescription')}
                </Text>


                <Form.Item style={{ marginBottom: '24px' }}>
                    <Button
                        htmlType="submit"
                        block
                    >
                        {t('auth.avigilonLogin')}
                    </Button>
                </Form.Item>
            </Form >
            <Button
                onClick={onBack}
                type="link"
                className="button"
                style={{ fontWeight: 'bold' }}
            >
                {t('auth.returnToSignIn')}
            </Button>
        </>
    );
};

export default AlternateLogin;
